module.exports = __webpack_public_path__ + "img/19.9.TU.6d15ed9e.png";